module.exports = __webpack_public_path__ + "img/logo.2a7a09b2.png";